import { signInWithCustomToken, signOut } from 'firebase/auth';
import { getFunctions, httpsCallable } from 'firebase/functions';
import app, { auth } from './firebase/config';

const EXPECTED_TARGET = 'przekroj';
const FUNCTIONS_REGION = 'europe-west3';

function ssoDebugLog(step, extra) {
  try {
    const log = JSON.parse(localStorage.getItem('__przekroj_sso_debug') || '[]');
    log.push({ step, time: new Date().toISOString(), ...extra });
    localStorage.setItem('__przekroj_sso_debug', JSON.stringify(log.slice(-20)));
    console.log('[Przekroje SSO]', step, extra);
  } catch (_) { }
}

// Odczyt i NATYCHMIASTOWE wymazanie kodu z URL (zanim cokolwiek innego).
function takeHandoffCodeFromUrl() {
  if (typeof window === 'undefined') return null;

  // Hash moze byc juz wyczyszczony przez firebase-auth init lub inny modul
  // ladowany przed bootstrap(). Czytamy snapshot z public/index.html (inline
  // script ktory robi window.__ssoHashSnapshot = location.hash przed
  // ladowaniem bundla).
  const snapshotHash = window.__ssoHashSnapshot || '';
  const currentHash = window.location.hash || '';
  const hash = snapshotHash || currentHash;

  ssoDebugLog('handler-called', { snapshotHash, currentHash, used: hash });

  if (!hash || hash.length < 2) {
    ssoDebugLog('no-hash', { snapshotLen: snapshotHash.length, currentLen: currentHash.length });
    return null;
  }

  const params = new URLSearchParams(hash.startsWith('#') ? hash.slice(1) : hash);
  const code = params.get('sso');
  if (!code) {
    ssoDebugLog('no-sso-param', { hashStart: hash.slice(0, 30) });
    return null;
  }

  ssoDebugLog('code-found', { codeLen: code.length, codeStart: code.slice(0, 8) });

  params.delete('sso');
  const remaining = params.toString();
  const newUrl =
    window.location.pathname +
    window.location.search +
    (remaining ? `#${remaining}` : '');
  window.history.replaceState(null, '', newUrl);

  return code.trim() || null;
}

// Guard: redeem jest single-use. React 18 StrictMode w dev nie wpływa na
// bootstrap() (init modułu wykonuje się raz), ale guard chroni przed
// przypadkowym drugim wywołaniem z innych miejsc.
let ssoInFlight = null;

export function consumeSsoTokenFromUrl() {
  if (!ssoInFlight) ssoInFlight = doConsume();
  return ssoInFlight;
}

async function doConsume() {
  const code = takeHandoffCodeFromUrl();
  if (!code) return 'no-token';

  try {
    const functions = getFunctions(app, FUNCTIONS_REGION);
    const redeem = httpsCallable(functions, 'redeemCptSsoToken');
    const { data } = await redeem({ code });
    const customToken = data?.customToken;
    if (!customToken) {
      ssoDebugLog('redeem-no-token', { keys: Object.keys(data || {}) });
      return 'error';
    }
    ssoDebugLog('redeem-ok', { target: data?.target });

    const cred = await signInWithCustomToken(auth, customToken);
    ssoDebugLog('signed-in', { uid: cred.user?.uid, email: cred.user?.email });

    // Custom token jest wazny dla CALEGO projektu Firebase — kod wystawiony
    // dla innej apki (np. 'cpt') technicznie zalogowalby tez tutaj.
    // Wymuszamy zgodnosc target z developerClaims.
    const tokenResult = await cred.user.getIdTokenResult();
    const target = tokenResult.claims?.target;
    if (target && target !== EXPECTED_TARGET) {
      ssoDebugLog('target-mismatch', { expected: EXPECTED_TARGET, got: target });
      await signOut(auth);
      return 'error';
    }

    return 'signed-in';
  } catch (err) {
    ssoDebugLog('sso-error', {
      code: err?.code,
      message: err?.message?.slice(0, 200),
    });
    console.warn('[Przekroje SSO] redeem/sign-in failed', err);
    return 'error';
  }
}
